<template>
    <tr>
        <td>
            <button v-if="checkIfEditEnabled" class="button is-primary" @click="updateItem">
                <i class="fas fa-save"></i>
            </button>
            <button  v-if="!checkIfEditEnabled" class="button" @click="editItem">
                <i class="fas fa-edit"></i>
            </button>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.name"></span>
            <input class="input" v-if="checkIfEditEnabled" v-model="name"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.inland_transport }}</span>
            <input class="input" v-if="checkIfEditEnabled" v-model="inland_transport"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.total }}</span>
            <input class="input" v-if="checkIfEditEnabled" v-model="total"/>
        </td>
        <td>
            <button class="button is-danger" v-if="index > 0" @click="deleteItem">
                <i class="fas fa-trash"></i>
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        props:['item', 'index'],
        computed: {
            checkIfEditEnabled() {
                return this.$store.getters.getCustomInvoiceSelectedSaleItem.id === this.item.id
            },
            name: {
                get() {
                   return this.$store.getters.getCustomInvoiceSelectedSaleItem.name
                },
                set(value) {
                   this.$store.dispatch('changeCustomInvoiceSelectedSaleItemFieldValue', { field: 'name', value: value})
                }
            },
            inland_transport: {
                get() {
                    return this.$store.getters.getCustomInvoiceSelectedSaleItem.inland_transport
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceSelectedSaleItemFieldValue', { field: 'inland_transport', value: value})
                }
            },
            total: {
                get() {
                    return this.$store.getters.getCustomInvoiceSelectedSaleItem.total
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceSelectedSaleItemFieldValue', { field: 'total', value: value})
                }
            }
        },
        methods: {
            editItem() {
                this.$store.dispatch('changeCustomInvoiceSelectedSaleItem', this.item)
                this.$store.dispatch('changeCustomInvoiceSelectedSaleItemIndex', this.index)
            },
            updateItem() {
                this.$store.dispatch('updateCustomInvoiceSaleItem')
                this.$store.dispatch('changeCustomInvoiceTotalSaleAmount')
                this.$store.dispatch('calculateCustomInvoice')
            },
            deleteItem() {
                this.$store.dispatch('deleteCustomInvoiceSaleItem', this.item)
                this.$store.dispatch('changeCustomInvoiceTotalSaleAmount')
                this.$store.dispatch('calculateCustomInvoice')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceSalesTableRow.vue